import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './FaceBubble.scss';
import CheckedCircleIcon from './icons/CheckedCircleIcon';

const FaceBubble = ({ size, imageSource, faceName, faceJobTitle }) => {
  const imageWrapperClass = classNames('face-bubble__image-wrapper', {
    'face-bubble__image-wrapper--big': size === 'big',
    'face-bubble__image-wrapper--small': size === 'small'
  });
  const imageIconContainerClass = classNames(
    'face-bubble__image-icon-container',
    {
      'face-bubble__image-icon-container--small': size === 'small'
    }
  );
  const iconWrapperClass = classNames('face-bubble__icon-wrapper', {
    'face-bubble__icon-wrapper--small': size === 'small'
  });
  return (
    <div className="face-bubble__container">
      <div>
        <div className={imageIconContainerClass}>
          <div
            style={{
              backgroundImage: `url(${imageSource})`
            }}
            className={imageWrapperClass}
          />
          <span className={iconWrapperClass}>
            <CheckedCircleIcon />
          </span>
        </div>
      </div>

      <div className="face-bubble__details">
        <p className="face-bubble__name">{faceName}</p>
        <p className="face-bubble__title">{faceJobTitle}</p>
      </div>
    </div>
  );
};

FaceBubble.propTypes = {
  size: PropTypes.oneOf(['big', 'small']).isRequired,
  imageSource: PropTypes.string.isRequired,
  faceName: PropTypes.string.isRequired,
  faceJobTitle: PropTypes.string.isRequired
};

export default FaceBubble;
